import { UserAvatar } from '@medcom/shared-ui/components/UserAvatar.tsx';
import type React from 'react';
import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useGetUserInfo } from './api/user-info.queries.ts';
import { UserMenu } from './components/UserMenu';
import { oidcConfig } from './oidcConfig.ts';
import { useSocket } from './socket/useSocket.ts';
import { Role, realmRoles, translateRole, userFullname } from './utils/user';

export const UserMenuWrapper: React.FC = () => {
  const auth = useAuth();
  const { socket } = useSocket();
  const { data } = useGetUserInfo();

  const roleNames =
    realmRoles(auth.user)
      .filter(it => Object.keys(Role).includes(it))
      .map(it => translateRole(it))
      .join(', ') ?? '';

  useEffect(() => {
    socket.on('sso-logout', event => {
      if (auth.user?.session_state === event.sessionId) {
        auth.signoutRedirect(); // redirects to kc logout page
      }
    });
    return () => {
      socket.off('sso-logout');
    };
  }, [socket, auth]);

  const userFullName = userFullname(auth.user, auth.user?.profile.preferred_username);
  const accountName = data?.accountName ? data.accountName : 'Kein Account festgelegt';

  return (
    <UserMenu
      roleName={roleNames}
      username={auth.user?.profile.preferred_username}
      avatar={
        <UserAvatar
          userId={auth.user?.profile.sub}
          givenName={auth.user?.profile.given_name}
          familyName={auth.user?.profile.family_name}
          username={auth.user?.profile.preferred_username}
        />
      }
      accountName={accountName}
      accountDisabled={data?.accountDisabled ?? false}
      userFullName={userFullName}
      onUserAccountOpen={() => {
        window.location.href =
          oidcConfig.authority + `/account?referrer=${oidcConfig.client_id}&referrer_uri=${encodeURIComponent(window.location.href)}`;
      }}
      onLogout={() => {
        const sessionId = auth.user?.session_state;
        if (sessionId) {
          socket.emit('sso-logout', sessionId);
        }
      }}
    />
  );
};
